import { observer } from 'mobx-react-lite';
import React from 'react'
import Picture from '../../../Models/Picture';
import { useStore } from '../../../Stores/store';


export default observer(function PosterPreview(){
    const { managementStore, posterStore } = useStore();
    const { isPreviewingPoster, previewPoster, closePosterPreview, deletePicture } = managementStore;
    const { setNewCurrentPoster, deactivatePoster } = posterStore;

    if(isPreviewingPoster !== undefined && isPreviewingPoster === true && previewPoster !== undefined)
    {
        const poster : Picture | undefined = previewPoster;

        return (
            <div
                className="fixed inset-0 z-40 flex items-center justify-center bg-black/70"
                onClick={() => closePosterPreview()}
            >
                <div
                    className="relative bg-white rounded-lg shadow-xl w-[90%] sm:w-[70%] max-h-[90vh] flex flex-col overflow-hidden"
                    onClick={(e) => e.stopPropagation()}
                >
                    {/* Image */}
                    <div className="overflow-y-auto flex-1">
                        <img src={poster?.url} alt={poster?.alt} className="w-full h-auto block" />
                    </div>

                    {/* Action bar */}
                    <div className="flex items-center justify-between gap-2 px-4 py-3 border-t border-gray-200 bg-gray-50">
                        <button
                            className="px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-md hover:bg-green-700 transition-colors cursor-pointer"
                            onClick={() => setNewCurrentPoster(previewPoster.id)}
                        >
                            Set as Active
                        </button>
                        <button
                            className="px-4 py-2 text-sm font-medium text-yellow-800 bg-yellow-300 rounded-md hover:bg-yellow-400 transition-colors cursor-pointer"
                            onClick={() => deactivatePoster(previewPoster.id)}
                        >
                            Deactivate
                        </button>
                        <button
                            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-100 transition-colors cursor-pointer"
                            onClick={() => closePosterPreview()}
                        >
                            Cancel
                        </button>
                        <button
                            className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700 transition-colors cursor-pointer"
                            onClick={() => deletePicture(previewPoster.id)}
                        >
                            Delete Poster
                        </button>
                    </div>
                </div>
            </div>
        )
    }
    else {
        return null;
    }

});